import { DefaultTheme } from 'styled-components';

const fontSizes = {
  medium: '14.5px',
  large: '16px',
  small: '12px',
  md: '16px',

  xs: '10px',
  sm: '12px',
  normal: '14px',
  base: '16.2px',
  lg: '18px',
  xl: '24px',
  xxl: '32px',
  xxxl: '40px',
  xxxxl: '48px',
};

const fontWeights = {
  bold: '600',
  medium: '450',
  normal: '400',
};

// const paddings = {
//   small: calcRem(8),
//   base: calcRem(10),
//   large: calcRem(12),
// };

const margins = {
  marginRight: '0.4rem',
  bottomInPage: '1.3rem',
  bottomInModal: '1rem',
};
const viewSize = {
  xs: '320px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

// const device = {
//   mobileS: `only screen and (max-width: ${deviceSizes.mobileS})`,
//   mobileM: `only screen and (max-width: ${deviceSizes.mobileM})`,
//   mobileL: `only screen and (max-width: ${deviceSizes.mobileL})`,
//   tablet: `only screen and (max-width: ${deviceSizes.tablet})`,
//   tabletL: `only screen and (max-width: ${deviceSizes.tabletL})`,
// };
const colors = {
  primary: '#4D77FF',
  sub: '#56BBF1',
  yellow: '#fed049',
  yellow_sub: '#f7c847',
  table_button: '#cceaf9',
  table_header: '#e1f0f7',
  del_danger: '#fc8f8f',
  black: '#404040',
  darkNavy: '#555c66',
  blueText: '#293462',
  blueMain: '#46cdff',
  blue_01: '#00b0ff',
  blue_03: '#adcdd3',
  blue_04: '#03b0d4',
  blue_1: '#F0F5F9',
  blue_2: '#84b8e0',
  blue_4: '#c1d3e8',
  blue_6: '#6a7c8e',
  blue_7: '#566a7f',
  blue_8: '#B2FCFF',
  blue_50: '#eaeffb',
  blue_100: '#bfcef2',
  blue_200: '#a0b7eb',
  blue_300: '#7496e2',
  blue_400: '#5981dd',
  blue_500: '#3062d4',
  blue_600: '#2c59c1',
  blue_700: '#224697',
  blue_800: '#1a3675',
  blue_900: '#142959',
  blue_focus: '#6792F4',
  green_50: '#e8f2ed',
  green_100: '#b9d6c8',
  green_200: '#97c3ad',
  green_300: '#68a788',
  green_400: '#4a9671',
  green_500: '#1d7c4d',
  green_600: '#1a7146',
  green_700: '#155837',
  green_800: '#10442a',
  green_900: '#0c3420',
  red_50: '#f9ebeb',
  red_100: '#edc0c0',
  red_200: '#e4a2a2',
  red_300: '#d87777',
  red_400: '#d15d5d',
  red_500: '#c53434',
  red_600: '#b32f2f',
  red_700: '#8c2525',
  red_800: '#6c1d1d',
  red_900: '#531616',
  yellow_50: '#fef5eb',
  yellow_100: '#fcdec1',
  yellow_200: '#facfa3',
  yellow_300: '#f8b97a',
  yellow_400: '#f7ab60',
  yellow_500: '#f59638',
  yellow_600: '#df8933',
  yellow_700: '#ae6b28',
  yellow_800: '#87531f',
  yellow_900: '#673f18',
  dark_50: '#e9eaeb',
  dark_100: '#bcbec0',
  dark_200: '#9c9fa2',
  dark_300: '#6e7378',
  dark_400: '#52585d',
  dark_500: '#272e35',
  dark_600: '#232a30',
  dark_700: '#1c2126',
  dark_800: '#15191d',
  dark_900: '#101316',
  gray_1: '#f7f7f7',
  gray_2: '#686868',
  gray_3: '#c4c4c4',
  gray_4: '#e8e8e8',
  gray_5: '#d9dee3', //rgb(217, 222, 227)
  gray_6: '#CFD6DD',
  gray_7: '#dbe0e6',
  gray_8: '#d2d2d2',
  redText: '#ff1900',
  server_orange: '#FF8A65',
  otomeSub2: '#9fe9ea',
  otomeSub: '#03b0d4',
  otomeBack: '#ECFCFF',
  otomePrimaryDark: '#1a6e70',
  aliceBlue: '#EDF2FF',
  antiFlashWhite: '#F0F3F5',
  grayContent: '#7E8B99',
  blackContent: '#4A545E',
  script_even_row: '#eee9f1',
  script_default_row: '#fff',
  script_side_back: '#f8f8ff',
  script_blue: '#3062d4',
  script_side_button: '#8a8dba',
  script_invalidate_row: '#f7b4b4',
};

export const theme: DefaultTheme = {
  fontSizes,
  colors,
  viewSize,
  margins,
  fontWeights,
};
